export const gitVersion = "1.3.121-prod-20261027-1-gb23ff40";
